module.exports = __webpack_public_path__ + "static/img/3056_phase_function_Paper_Points.e1688ea.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/3056_phase_function_Paper_Points.png
// module id = eIWV
// module chunks = 0